import { SectionMessage, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const WarningSection = styled(SectionMessage)`
  padding: ${Spacing.S2} ${Spacing.S16};
`
